import { UncontrolledAlert as Alert } from "reactstrap";

const Error = ({error}) => {
  return (
    <Alert closeClassName="pt-4 fs-6" color="danger" style={{fontSize: "14px"}}>{error}</Alert>
  )
}

export default Error